import(/* webpackMode: "eager" */ "/builds/vivaldis/vivaldis_interim/frontend/src/components/atoms/Loader.tsx")